<template>
  <footer class="site-footer">
    <div>Copyright Southern Company {{ thisYear() }} - All Rights Reserved</div>
  </footer>
</template>

<script setup>
import { thisYear } from '@shared/utils/date'
</script>
